import React from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import { PALETTE } from "../../common/ThemeConstants";
import DocsHeader from "../components/DocsHeader";
import ContainerResponsive from "../../common/components/ContainerResponsive";

export default function TermsOfService() {
  const sectionStyle = {
    marginBottom: "2.5rem",
    padding: "1.5rem",
    borderRadius: "8px",
    backgroundColor: PALETTE.LIGHTGRAY,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
  };

  const titleStyle = {
    color: PALETTE.SECONDARYCOLOR,
    marginBottom: "1rem",
    fontWeight: "600"
  };

  const subtitleStyle = {
    color: PALETTE.MAINCOLOR,
    marginTop: "1.5rem",
    marginBottom: "0.75rem",
    fontWeight: "500"
  };

  const linkStyle = {
    fontWeight: "bold",
    color: PALETTE.MAINCOLOR,
    textDecoration: "none",
    transition: "color 0.2s ease"
  };

  return (
    <>
      <DocsHeader />
      <ContainerResponsive>
        <Container>
          <Row style={{ color: PALETTE.DARK }}>
            <Col>
              <div className="text-center mb-5">
                <h1 style={{ fontWeight: "700", color: PALETTE.SECONDARYCOLOR }}>Termini di Servizio</h1>
                <h5 style={{ color: PALETTE.DARKGRAY }}>
                  Ultimo aggiornamento: 2 Aprile 2025
                </h5>
              </div>

              <Card className="mb-4 border-0" style={{ backgroundColor: PALETTE.LIGHTGRAYKINDATRANSPARENT }}>
                <Card.Body className="p-4">
                  <h5 style={{ color: PALETTE.SECONDARYCOLOR }}>Sommario</h5>
                  <p>
                    Benvenuto su Federico Bartoli PT! I seguenti termini di servizio disciplinano l'utilizzo della nostra piattaforma di coaching online. Utilizzando i nostri servizi, accetti di rispettare e di essere vincolato da questi Termini. Ti invitiamo a leggerli attentamente prima di utilizzare la piattaforma.
                  </p>
                </Card.Body>
              </Card>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>1. Accettazione dei Termini</h2>
                <p>
                  Utilizzando il sito web, l'applicazione o i servizi di Federico Bartoli PT, accetti di essere vincolato dai presenti Termini di Servizio. Se non accetti questi termini, ti preghiamo di non utilizzare i nostri servizi.
                </p>
                <p>
                  Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. Le modifiche avranno effetto immediato dopo la pubblicazione sul sito. L'uso continuato dei servizi dopo tali modifiche costituisce accettazione dei nuovi termini.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>2. Descrizione dei Servizi</h2>
                <p>
                  Federico Bartoli PT offre servizi di coaching online per l'allenamento fisico e il benessere. I nostri servizi includono, ma non sono limitati a:
                </p>
                <ul>
                  <li>Creazione di piani di allenamento personalizzati</li>
                  <li>Monitoraggio dei progressi</li>
                  <li>Supporto da parte di un personal trainer qualificato</li>
                  <li>Accesso a contenuti educativi relativi al fitness e al benessere</li>
                  <li>Strumenti per il tracciamento degli allenamenti</li>
                </ul>
                <p>
                  I servizi sono forniti "così come sono" e possono essere modificati o interrotti in qualsiasi momento senza preavviso.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>3. Registrazione e Account</h2>

                <h4 style={subtitleStyle}>3.1 Creazione dell'account</h4>
                <p>
                  Per utilizzare i nostri servizi, è necessario registrarsi e creare un account. Durante la registrazione, ti verrà richiesto di fornire informazioni accurate e complete. Sei responsabile del mantenimento della riservatezza delle credenziali del tuo account.
                </p>

                <h4 style={subtitleStyle}>3.2 Responsabilità dell'account</h4>
                <p>
                  Sei l'unico responsabile di tutte le attività che si verificano sotto il tuo account. Ti impegni a:
                </p>
                <ul>
                  <li>Fornire informazioni accurate, aggiornate e complete</li>
                  <li>Mantenere la riservatezza della tua password</li>
                  <li>Limitare l'accesso al tuo account</li>
                  <li>Notificarci immediatamente di qualsiasi uso non autorizzato del tuo account</li>
                </ul>

                <h4 style={subtitleStyle}>3.3 Restrizioni dell'account</h4>
                <p>
                  Non è consentito:
                </p>
                <ul>
                  <li>Creare più di un account per persona</li>
                  <li>Condividere il tuo account con altre persone</li>
                  <li>Utilizzare l'account di un'altra persona</li>
                  <li>Vendere, trasferire o assegnare il tuo account a terzi</li>
                </ul>
                <p>
                  Ci riserviamo il diritto di sospendere o terminare il tuo account in caso di violazione di queste restrizioni.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>4. Abbonamenti e Pagamenti</h2>

                <h4 style={subtitleStyle}>4.1 Piani di abbonamento</h4>
                <p>
                  Federico Bartoli PT offre diversi piani di abbonamento per accedere ai servizi. I dettagli dei piani, inclusi prezzi e funzionalità, sono disponibili sul nostro sito web.
                </p>

                <h4 style={subtitleStyle}>4.2 Elaborazione dei pagamenti</h4>
                <p>
                  Tutti i pagamenti sono gestiti tramite la piattaforma Stripe. Accetti di fornire informazioni accurate e complete per l'elaborazione dei pagamenti. I prezzi sono indicati in Euro e includono l'IVA applicabile.
                </p>

                {/* <h4 style={subtitleStyle}>4.3 Rinnovo automatico</h4>
                <p>
                  Gli abbonamenti si rinnovano automaticamente alla fine del periodo di abbonamento, a meno che non venga annullato prima della data di rinnovo. Puoi annullare il rinnovo automatico in qualsiasi momento attraverso le impostazioni del tuo account.
                </p>

                <h4 style={subtitleStyle}>4.4 Politica di rimborso</h4>
                <p>
                  Offriamo un periodo di garanzia di soddisfazione di 14 giorni dalla data di acquisto. Se non sei soddisfatto dei nostri servizi, puoi richiedere un rimborso completo entro questo periodo. Dopo 14 giorni, non saranno concessi rimborsi per i periodi di abbonamento non utilizzati.
                </p>
                <p>
                  Per richiedere un rimborso, contattaci all'indirizzo email: <a href="mailto:fedebartopt@gmail.com" style={linkStyle}>fedebartopt@gmail.com</a>.
                </p> */}
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>5. Utilizzo dei Servizi</h2>

                <h4 style={subtitleStyle}>5.1 Uso consentito</h4>
                <p>
                  Puoi utilizzare i nostri servizi solo per scopi legali e in conformità con questi Termini. Ti impegni a non utilizzare i servizi per:
                </p>
                <ul>
                  <li>Violare leggi o regolamenti applicabili</li>
                  <li>Violare i diritti di terzi</li>
                  <li>Pubblicare contenuti offensivi, diffamatori o illegali</li>
                  <li>Trasmettere virus o codice dannoso</li>
                  <li>Interferire con il funzionamento dei servizi</li>
                  <li>Raccogliere informazioni sugli altri utenti senza il loro consenso</li>
                </ul>

                <h4 style={subtitleStyle}>5.2 Contenuti dell'utente</h4>
                <p>
                  Potresti avere la possibilità di pubblicare contenuti sulla piattaforma (come foto, commenti o feedback). Manterrai la proprietà di tali contenuti, ma ci concedi una licenza mondiale, non esclusiva, gratuita, trasferibile e sublicenziabile per utilizzare, riprodurre, modificare, adattare, pubblicare e distribuire tali contenuti in relazione ai nostri servizi.
                </p>
                <p>
                  Ti impegni a non pubblicare contenuti che violino i diritti di terzi o che siano illegali, offensivi, diffamatori o inappropriati. Ci riserviamo il diritto di rimuovere qualsiasi contenuto a nostra discrezione.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>6. Proprietà Intellettuale</h2>
                <p>
                  Tutti i contenuti, i materiali e le caratteristiche presenti su Federico Bartoli PT, comprese ma non limitate a testi, grafica, loghi, immagini, video, software e codice, sono di proprietà di Federico Bartoli PT o dei suoi licenziatari e sono protetti dalle leggi sulla proprietà intellettuale.
                </p>
                <p>
                  Non è consentito copiare, modificare, distribuire, vendere, noleggiare, prestare o utilizzare i contenuti senza previa autorizzazione scritta. L'uso non autorizzato di qualsiasi contenuto può violare le leggi sul copyright, sui marchi e altre leggi applicabili.
                </p>
                <p>
                  Ti concediamo una licenza limitata, non esclusiva, non trasferibile e revocabile per accedere e utilizzare i servizi per uso personale e non commerciale.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>7. Limitazione di Responsabilità</h2>
                <p>
                  Nei limiti consentiti dalla legge, Federico Bartoli PT e i suoi affiliati, dipendenti, agenti e partner non saranno responsabili per:
                </p>
                <ul>
                  <li>Danni diretti, indiretti, incidentali, speciali, consequenziali o punitivi</li>
                  <li>Perdita di profitti, dati, uso, avviamento o altre perdite immateriali</li>
                  <li>Danni derivanti dall'interruzione, sospensione o cessazione dei servizi</li>
                  <li>Danni derivanti da virus, attacchi informatici o altri materiali tecnologicamente dannosi</li>
                  <li>Danni derivanti da contenuti di terzi accessibili tramite i servizi</li>
                </ul>
                <p>
                  L'uso dei servizi avviene a tuo rischio e pericolo. I servizi sono forniti "così come sono" e "come disponibili", senza garanzie di alcun tipo, esplicite o implicite.
                </p>
                <p>
                  Riconosci che Federico Bartoli PT non è un professionista medico e che i servizi non costituiscono consulenza medica. Consulta sempre un medico prima di iniziare qualsiasi programma di esercizio fisico.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>8. Indennizzo</h2>
                <p>
                  Accetti di indennizzare, difendere e tenere indenne Federico Bartoli PT e i suoi affiliati, dipendenti, agenti e partner da qualsiasi reclamo, responsabilità, danno, perdita e spesa, incluse ragionevoli spese legali, derivanti da o in qualsiasi modo connessi a:
                </p>
                <ul>
                  <li>Il tuo accesso o utilizzo dei servizi</li>
                  <li>La violazione di questi Termini</li>
                  <li>La violazione di diritti di terzi</li>
                  <li>Il tuo comportamento in relazione ai servizi</li>
                </ul>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>9. Modifiche e Cessazione dei Servizi</h2>
                <p>
                  Ci riserviamo il diritto di modificare, sospendere o interrompere, temporaneamente o permanentemente, i servizi o qualsiasi parte di essi in qualsiasi momento, con o senza preavviso. Non saremo responsabili nei tuoi confronti o nei confronti di terzi per qualsiasi modifica, sospensione o interruzione dei servizi.
                </p>
                <p>
                  Ci riserviamo inoltre il diritto di limitare, sospendere o terminare il tuo accesso ai servizi in caso di violazione di questi Termini o di comportamento che riteniamo dannoso per altri utenti, per noi o per terzi.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>10. Legge Applicabile e Risoluzione delle Controversie</h2>
                <p>
                  Questi Termini sono regolati e interpretati in conformità con le leggi dell'Italia, senza riguardo ai suoi principi di conflitto di leggi.
                </p>
                <p>
                  Qualsiasi controversia derivante da o relativa a questi Termini o ai servizi sarà risolta in via amichevole attraverso negoziati in buona fede. Se non è possibile raggiungere una soluzione amichevole, la controversia sarà sottoposta alla giurisdizione esclusiva dei tribunali competenti in Italia.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>11. Disposizioni Generali</h2>

                <h4 style={subtitleStyle}>11.1 Intero accordo</h4>
                <p>
                  Questi Termini costituiscono l'intero accordo tra te e Federico Bartoli PT riguardo all'utilizzo dei servizi e sostituiscono qualsiasi accordo precedente.
                </p>

                <h4 style={subtitleStyle}>11.2 Rinuncia e separabilità</h4>
                <p>
                  La mancata applicazione di qualsiasi diritto o disposizione di questi Termini non costituirà una rinuncia a tale diritto o disposizione. Se una qualsiasi disposizione di questi Termini è ritenuta invalida o inapplicabile, le restanti disposizioni rimarranno in vigore.
                </p>

                <h4 style={subtitleStyle}>11.3 Cessione</h4>
                <p>
                  Non puoi cedere o trasferire questi Termini o i tuoi diritti e obblighi ai sensi di questi Termini senza il nostro previo consenso scritto. Possiamo cedere o trasferire questi Termini, in tutto o in parte, senza restrizioni.
                </p>

                <h4 style={subtitleStyle}>11.4 Forza maggiore</h4>
                <p>
                  Non saremo responsabili per il mancato adempimento di qualsiasi obbligo ai sensi di questi Termini a causa di cause al di fuori del nostro controllo, inclusi ma non limitati a calamità naturali, guerre, terrorismo, rivolte, embarghi, atti delle autorità civili o militari, incendi, inondazioni, incidenti, epidemie, pandemie o scioperi.
                </p>
              </div>

              <div style={sectionStyle}>
                <h2 style={titleStyle}>12. Contattaci</h2>
                <p>
                  Se hai domande, commenti o richieste relative a questi Termini di Servizio, non esitare a contattarci:
                </p>
                <p>
                  <strong>Email:</strong> <a href="mailto:fedebartopt@gmail.com" style={linkStyle}>fedebartopt@gmail.com</a>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </ContainerResponsive>
    </>
  );
}
